const map = {
  // 赔付管理
  compensationTrack: () => import('@/views/compensation/CompensationTrack'),
  // 赔付管理新增
  addCompensationTrack: () =>
    import('@/views/compensation/AddCompensationTrack'),
  // 赔付追踪管理详情
  compensationTrackDetail: () =>
    import('@/views/compensation/CompensationTrackDetail')
}

export default map
